import { useHistory, useLocation, useParams } from 'react-router';
import { VitalHistory } from '../../api/fetchPastVitals';

import AppHeader from '../../components/AppHeader';
import { VitalDetailsRouteProps } from '../routes';
import { DELAY_DUE_TO_RIPPLE } from './VitalsHome';

const VitalsDetailsPage: React.FC = () => {
    const { vid }: VitalDetailsRouteProps = useParams();

    const location = useLocation<{ k: string; data?: VitalHistory }>();

    if (!vid || !location?.state?.data) {
        return null;
    }

    const history = useHistory();

    const goBack = () => {
        setTimeout(() => {
            history.goBack();
        }, DELAY_DUE_TO_RIPPLE);
    };

    const order = location.state.data.column.map((c) => c.key);

    return (
        <div className="flex flex-col h-full font-grotesk">
            <AppHeader title={location.state.data.name} goBack={goBack} />
            <div className="mx-8 overflow-auto" style={{ height: 'calc(100% - 64px)' }}>
                <table className="w-full flex-auto px-16 overflow-auto bg-white mt-16">
                    <tr>
                        {location.state.data.column.map((c) => (
                            <td
                                key={c.key}
                                className="sticky top-0 px-8 py-6 uppercase text-11 font-700 text-text-secondary bg-background-secondary"
                            >
                                <p>{c.val}</p>
                            </td>
                        ))}
                    </tr>

                    {location.state.data.values.map((row, i) => (
                        <tr key={`${location?.state?.data?.name}-${i}`}>
                            {order.map((o, ii) => (
                                <td
                                    style={{ fontWeight: 500 }}
                                    key={`${o}-${ii}`}
                                    className={`px-8 leading-6 py-6 text-14 text-text-secondary ${o}`}
                                >
                                    <p>{row[o]}</p>
                                </td>
                            ))}
                        </tr>
                    ))}
                </table>
            </div>
            {/* <div className="flex items-center justify-between w-full px-16 py-12 shadow-bottom-sheet">
                <div className="flex items-center justify-center w-full">
                    <button className="px-16 py-10 primary-btn text-14 font-700">
                        Add Temperature
                    </button>
                </div>
            </div> */}
        </div>
    );
};

export default VitalsDetailsPage;
